<template>
  <Discovery />
</template>

<script lang="ts" setup>
import Discovery from "@/apps/credit-line/components/Discovery.vue";
</script>

<style lang="scss" scoped></style>
